"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceLimits = exports.CargoLosses = exports.Terminal = exports.VerifyDetails = exports.eConstructionTypeTerminal = exports.eProtectiveMeasuresAndProtocolsTerminal = exports.eDesiredDeductible = void 0;
const cargoLosses_class_1 = require("./cargoLosses.class");
Object.defineProperty(exports, "CargoLosses", { enumerable: true, get: function () { return cargoLosses_class_1.CargoLosses; } });
const insuranceLimits_class_1 = require("./insuranceLimits.class");
Object.defineProperty(exports, "InsuranceLimits", { enumerable: true, get: function () { return insuranceLimits_class_1.InsuranceLimits; } });
const terminal_class_1 = require("./terminal.class");
Object.defineProperty(exports, "Terminal", { enumerable: true, get: function () { return terminal_class_1.Terminal; } });
const verifyDetails_class_1 = __importDefault(require("./verifyDetails.class"));
exports.VerifyDetails = verifyDetails_class_1.default;
var eDesiredDeductible;
(function (eDesiredDeductible) {
    eDesiredDeductible["ONE_THOUSAND"] = "1000";
    eDesiredDeductible["TWO_THOUSAND_FIVE_HUNDRED"] = "2500";
    eDesiredDeductible["FIVE_THOUSAND"] = "5000";
    eDesiredDeductible["TEN_THOUSAND"] = "10000";
    eDesiredDeductible["TWENTY_FIVE_THOUSAND"] = "25000";
    eDesiredDeductible["FIFTY_THOUSAND"] = "50000";
    eDesiredDeductible["ONE_HUNDRED_THOUSAND"] = "100000";
})(eDesiredDeductible = exports.eDesiredDeductible || (exports.eDesiredDeductible = {}));
var eProtectiveMeasuresAndProtocolsTerminal;
(function (eProtectiveMeasuresAndProtocolsTerminal) {
    eProtectiveMeasuresAndProtocolsTerminal["NONE_APPLY"] = "None Apply";
    eProtectiveMeasuresAndProtocolsTerminal["CAMERAS"] = "Cameras";
    eProtectiveMeasuresAndProtocolsTerminal["FENCING"] = "Fencing";
    eProtectiveMeasuresAndProtocolsTerminal["LIGHTING"] = "Lighting";
    eProtectiveMeasuresAndProtocolsTerminal["LOCKING_GATE"] = "Locking Gate";
    eProtectiveMeasuresAndProtocolsTerminal["KINGPIN_LOCKS"] = "Kingpin Locks (trailers)";
    eProtectiveMeasuresAndProtocolsTerminal["LOCAL_ALARM_SYSTEM"] = "Local Alarm System (unmonitored)";
    eProtectiveMeasuresAndProtocolsTerminal["CENTRAL_STATION_MONITORED"] = "Central Station Monitored Alarm System";
    eProtectiveMeasuresAndProtocolsTerminal["TEMPERATURE_MONITORING_DEVICE"] = "Temperature Monitoring Device (Refrigeration Units)";
    eProtectiveMeasuresAndProtocolsTerminal["ON_SITE_SECURITY_GUARD_SERVICE"] = "24 Hour On-Site Security Guard Service";
})(eProtectiveMeasuresAndProtocolsTerminal = exports.eProtectiveMeasuresAndProtocolsTerminal || (exports.eProtectiveMeasuresAndProtocolsTerminal = {}));
var eConstructionTypeTerminal;
(function (eConstructionTypeTerminal) {
    eConstructionTypeTerminal["FRAME"] = "Frame";
    eConstructionTypeTerminal["JOISTED_MASONRY"] = "Joisted Masonry";
    eConstructionTypeTerminal["NONCOMBUSTIBLE"] = "Non-Combustible";
    eConstructionTypeTerminal["MASONRY_NONCOMBUSTIBLE"] = "Masonry Non-Combustible";
    eConstructionTypeTerminal["MODIFIED_FIRE_RESISTIVE"] = "Modified Fire Resistive";
    eConstructionTypeTerminal["FIRE_RESISTIVE"] = "Fire Resistive";
    eConstructionTypeTerminal["UNKNOWN_CONSTRUCTION_TYPE"] = "Yard/Lot/No Building/Unknown Construction Type";
})(eConstructionTypeTerminal = exports.eConstructionTypeTerminal || (exports.eConstructionTypeTerminal = {}));
//# sourceMappingURL=index.js.map